import { render, staticRenderFns } from "./ChangePwd.vue?vue&type=template&id=765bf5ed&scoped=true&lang=pug&"
import script from "./ChangePwd.vue?vue&type=script&lang=js&"
export * from "./ChangePwd.vue?vue&type=script&lang=js&"
import style0 from "./ChangePwd.vue?vue&type=style&index=0&id=765bf5ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765bf5ed",
  null
  
)

export default component.exports